export default "__VITE_ASSET__CIchw8Sf__"